













import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch,
  Mixins
} from "vue-property-decorator";
import Button from "@/components/Button/Button.vue";

@Component({
  components: { Button }
})
export default class AddAcount extends Vue {
  @Emit("clickLiteSearch")
  private clickLiteSearch() {
    console.log("click");
  }
}
